import BlobImage from 'components/blobImage';
import { Copy, SystemText } from 'e4shared';
import React from 'react';
import { ratingColour } from 'helpers/metrics';
import { withRouter } from 'react-router-dom';

export const UserRecommendations = ({ text, users, history }) => {
    return (
        <div>
            <p>
                <Copy value={text} />
            </p>
            <ul>
                {users.map(u => (
                    <li
                        data-testid={`li-comps-${u.id}`}
                        key={`comps-${u.id}`}
                        className="flex flex-center list-image pointer"
                        onClick={() => history.push(`develop/performance-dashboard/${u.id}`)}
                        title={SystemText('Dashboard/Widgets/General/Recommends/Visit', u.first_Name)}
                    >
                        <BlobImage folder="avatar" src={u.avatar} initials={u.initials} className="mr5 img-circle" />
                        <span style={{ width: '30px' }} title={SystemText('Dashboard/Widgets/General/Recommends/Rated')}>
                            <label className={`label label-${ratingColour(u.value)} mr10`}>
                                <span style={{ width: '15px', display: 'inline-block', textAlign: 'center' }}>
                                    {u.value?.toFixed(0)}
                                </span>
                            </label>
                        </span>
                        <span className="ml5 flex-grow">{u.full_Name}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default withRouter(UserRecommendations);
